var _defs, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_10",
    width: 32.681,
    height: 30.448,
    viewBox: "0 0 32.681 30.448",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:none;stroke:#b8b8b8;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.cls-2{fill:#414141}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    d: "M31.9 28.168H.92a.774.774 0 0 1-.82-.82V6.2a.852.852 0 0 1 .328-.656.732.732 0 0 1 .82 0l15.08 7.056 15.08-6.884a.744.744 0 0 1 .82 0c.328.328.492.492.492.82v20.649a.918.918 0 0 1-.82.983zM1.739 26.529H31.08V7.843L16.819 14.4a.5.5 0 0 1-.656 0L1.739 7.515z",
    className: "cls-2",
    "data-name": "Path 134",
    transform: "translate(-.039 2.279)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    d: "M31.924 10.355c-.164 0-.328 0-.328-.164l-15.244-7.7-15.08 7.54A1.087 1.087 0 0 1 .124 9.7a.847.847 0 0 1 .492-1.148L16.188.848a.732.732 0 0 1 .82 0L32.579 8.88a1.031 1.031 0 0 1 0 .983c-.164.328-.327.492-.655.492z",
    className: "cls-2",
    "data-name": "Path 135",
    transform: "translate(-.063 -.725)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    d: "M21.739 10.9a.774.774 0 0 1-.82-.82V6.639H5.839v3.115a.774.774 0 0 1-.82.82.774.774 0 0 1-.82-.82V5.82A.774.774 0 0 1 5.02 5h16.719a.774.774 0 0 1 .82.82v4.262a.878.878 0 0 1-.82.818z",
    className: "cls-2",
    "data-name": "Path 136",
    transform: "translate(2.582 2.007)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_33",
    d: "M0 0h5.901v.656H0z",
    className: "cls-2",
    "data-name": "Rectangle 33",
    transform: "translate(10.388 9.958)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_34",
    d: "M0 0h8.196v.656H0z",
    className: "cls-2",
    "data-name": "Rectangle 34",
    transform: "translate(10.388 12.089)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.8c1cb61a6253b78019040fc56146d0d4.svg";
export { ForwardRef as ReactComponent };